import React, { useState, useEffect } from "react";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./MultiSelect.module.sass";
import Tooltip from "../Tooltip";

const MultiSelect = ({
    className,
    classDropdownHead,
    classDropdownLabel,
    value,
    setValue,
    options,
    label,
    tooltip,
    small,
    upBody,
    name,
}) => {
    const [visible, setVisible] = useState(false);
    const [selectedValues, setSelectedValues] = useState([]);

    // Initialiser les valeurs sélectionnées à partir de la prop value
    useEffect(() => {
        if (Array.isArray(value)) {
            setSelectedValues(value);
        } else if (value && typeof value === 'object') {
            setSelectedValues([value]);
        } else if (value) {
            setSelectedValues([{ value }]);
        } else {
            setSelectedValues([]);
        }
    }, [value]);

    // Gérer le clic sur une option
    const handleClick = (option) => {
        let newSelectedValues;
        
        // Vérifier si l'option est déjà sélectionnée
        const optionValue = option.value || option;
        const isSelected = selectedValues.some(item => 
            (item.value || item) === optionValue
        );
        
        if (isSelected) {
            // Retirer l'option des sélections
            newSelectedValues = selectedValues.filter(item => 
                (item.value || item) !== optionValue
            );
        } else {
            // Ajouter l'option aux sélections
            newSelectedValues = [...selectedValues, option];
        }
        
        // Mettre à jour l'état local
        setSelectedValues(newSelectedValues);
        
        // Appeler la fonction setValue du parent avec les nouvelles valeurs
        setValue({
            target: {
                name,
                value: newSelectedValues.map(item => item.value || item)
            }
        });
    };

    // Formater le texte à afficher dans la zone de sélection
    const getSelectionText = () => {
        if (selectedValues.length === 0) {
            return 'Sélectionner';
        } else if (selectedValues.length === 1) {
            const selected = selectedValues[0];
            return selected.title || selected.value || selected;
        } else {
            return `${selectedValues.length} sélectionnés`;
        }
    };

    return (
        <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
            {label && (
                <div className={cn(styles.label, classDropdownLabel)}>
                    {label}{" "}
                    {tooltip && (
                        <Tooltip
                            className={styles.tooltip}
                            title={tooltip}
                            icon="info"
                            place="right"
                        />
                    )}
                </div>
            )}
            <div
                className={cn(
                    styles.dropdown,
                    className,
                    { [styles.small]: small },
                    { [styles.active]: visible }
                )}
            >
                <div
                    className={cn(styles.head, classDropdownHead)}
                    onClick={() => setVisible(!visible)}
                >
                    <div className={styles.selection}>
                        {getSelectionText()}
                    </div>
                </div>
                <div className={cn(styles.body, { [styles.bodyUp]: upBody })}>
                    {options.map((option, index) => {
                        // Déterminer si cette option est sélectionnée
                        const optionValue = option.value || option;
                        const isSelected = selectedValues.some(item => 
                            (item.value || item) === optionValue
                        );
                        
                        // Déterminer le texte à afficher
                        const displayText = option.title || option.value || option;
                            
                        return (
                            <div
                                className={cn(styles.option, {
                                    [styles.selectioned]: isSelected,
                                })}
                                onClick={() => handleClick(option)}
                                key={index}
                            >
                                <div className={styles.checkbox}>
                                    {isSelected && (
                                        <div className={styles.check}>✓</div>
                                    )}
                                </div>
                                <span>{displayText}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </OutsideClickHandler>
    );
};

export default MultiSelect;
